<template>
  <div>
    <a-list style="height: 100%">
      <div slot="header" style="padding-top: 20px">
        <span class="titleClass">账号与密码</span>
        <br/><br/>
        <span>帐号设置/密码修改</span>
      </div>
      <a-list-item style="padding: 20px">
        <span>修改密码</span>
        <a-button type="link" icon="edit" style="position: absolute;right: 5px;font-size: 24px;" @click="editPassword"/>
        <br/><br/>
        ******
      </a-list-item>
      <a-list-item style="padding: 20px">
        <span>绑定邮箱</span>
        <a-button type="link" icon="edit" style="position: absolute;right: 5px;font-size: 24px;" @click="bindMailbox"/>
        <br/><br/>
        {{ $store.state.userInfo.email }}
      </a-list-item>
      <a-list-item style="padding: 20px">
        <span>绑定手机</span>
        <a-button type="link" icon="edit" disabled style="position: absolute;right: 5px;font-size: 24px;"/>
        <br/><br/>
        137*******2333
      </a-list-item>
    </a-list>
    <a-modal v-model="editPasswordVisible" title="修改密码" ok-text="确认" cancel-text="取消" @ok="submitPassword"
             :confirm-loading="confirmLoading">
      <a-form-model layout="vertical" :model="editPasswordForm" ref="editPasswordForm" :rules="rules" :onload="true">
        <a-form-model-item label="请输入原密码" prop="currentPass">
          <a-input-password v-model="editPasswordForm.currentPass" placeholder="请输入原密码">
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
          </a-input-password>
        </a-form-model-item>
        <a-form-model-item label="请输入新密码" prop="newPass">
          <a-input-password v-model="editPasswordForm.newPass" placeholder="请输入新密码">
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
          </a-input-password>
        </a-form-model-item>
        <a-form-model-item label="请再次输入新密码" prop="repeatPass">
          <a-input-password v-model="editPasswordForm.repeatPass" placeholder="请输入新密码">
            <a-icon slot="prefix" type="lock" style="color:rgba(0,0,0,.25)"/>
          </a-input-password>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal v-model="bindMailboxVisible" title="绑定邮箱" ok-text="确认" cancel-text="取消" @ok="verifyEmail"
             :confirm-loading="confirmLoading">
      <a-form-model layout="vertical" :model="bindMailboxForm" ref="bindMailboxForm" :rules="emailRules" :onload="true"
                    :wrapper-col="{span: 20,offset: 2}">
        <a-form-model-item prop="email">
          <a-input v-model="bindMailboxForm.email" placeholder="请输入邮箱" allowClear size="large">
            <a-icon slot="prefix" type="mail" style="color:rgba(0,0,0,.25)"/>
          </a-input>
        </a-form-model-item>
        <a-form-model-item prop="code">
          <a-input v-model="bindMailboxForm.code" placeholder="请输入验证码" size="large">
            <a-button type="primary" slot="suffix" size="small" @click="sendVerificationEmail">获取验证码</a-button>
          </a-input>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>


import SystemUserRequest from "@/store/RequestModules/SystemUserRequest";
import UserInfoRequest from "@/store/RequestModules/UserInfoRequest";

export default {
  name: "AccountConfiguration",
  data() {
    let validatePass = (rule, value, callback) => {
      if (value !== this.editPasswordForm.newPass) {
        callback(new Error("两次密码输入不匹配"));
      } else {
        callback();
      }
    };
    let validateEmail = (rule, value, callback) => {
      if (/^\w{1,32}@[a-z0-9\-]{1,32}(\.[a-z]{2,6}){1,2}$/i.test(value) == false) {
        callback(new Error("邮箱格式错误"));
      } else {
        callback();
      }
    };
    return {
      editPasswordVisible: false,
      bindMailboxVisible: false,
      editPasswordForm: {
        currentPass: '',
        newPass: '',
        repeatPass: ''
      },
      bindMailboxForm: {
        email: '',
        code: ''
      },
      confirmLoading: false,
      rules: {
        currentPass: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
          {min: 3, message: '密码长度不能少于3位', trigger: 'blur'},
          {max: 20, message: '密码长度不能大于20位', trigger: 'blur'},
        ],
        newPass: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
          {min: 3, message: '密码长度不能少于3位', trigger: 'blur'},
          {max: 20, message: '密码长度不能大于20位', trigger: 'blur'},
        ],
        repeatPass: [
          {required: true, message: '密码不能为空', trigger: 'blur'},
          {min: 3, message: '密码长度不能少于3位', trigger: 'blur'},
          {max: 20, message: '密码长度不能大于20位', trigger: 'blur'},
          {validator: validatePass, trigger: 'blur'},
        ],
      },
      emailRules: {
        email: [
          {required: true, message: '邮箱不能为空', trigger: 'blur'},
          {validator: validateEmail, trigger: "blur"}
        ]
      }
    };
  },
  methods: {
    editPassword() {
      this.editPasswordVisible = true;
    },
    bindMailbox() {
      this.bindMailboxVisible = true;
    },
    submitPassword() {
      this.$refs.editPasswordForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          if (this.editPasswordForm.currentPass === this.editPasswordForm.newPass) {
            this.$message.error("新密码不能和原密码相同")
            this.confirmLoading = false
          } else {
            const param = {
              password: this.editPasswordForm.currentPass,
              newPassword: this.editPasswordForm.newPass,
            }
            SystemUserRequest.changePassword(param).then(res => {
              if (res.status == '200') {
                this.$message.success('密码修改成功')
                this.editPasswordVisible = false;
                this.$store.commit("REMOVE_INFO");
                const jwt = res.headers['token'];
                this.$store.commit("SET_TOKEN", jwt);
                //页面跳转
                // this.$router.push({name: 'SignIn'});
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        }
      })
    },
    sendVerificationEmail(){
      this.$refs.bindMailboxForm.validate(valid => {
        if (valid) {
          UserInfoRequest.sendVerificationEmail(this.bindMailboxForm.email).then(res => {
            if (res.status == '200') {
              this.$message.success('验证码已发送')
            }
          })
        }
      })
    },
    verifyEmail(){
      this.$refs.bindMailboxForm.validate(valid => {
        if (valid) {
          if(!this.bindMailboxForm.code){
            this.$message.error('验证码不能为空')
            return
          }
          UserInfoRequest.verifyEmail(this.bindMailboxForm.email, this.bindMailboxForm.code).then(res => {
            if (res.status == '200') {
              this.$message.success('绑定成功')
              this.$store.state.userInfo.email = this.bindMailboxForm.email
            }
          })
        }
      })
    }

  },

}
</script>

<style scoped>
.titleClass {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
}
</style>